import { ReactNode } from 'react';
import { Modal } from '../ui/modal';

interface CatalogModalFrameProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: ReactNode;
    className?: string;
    bodyClassName?: string;
    formId?: string;
    submitLabel?: string;
    submitDisabled?: boolean;
    footer?: ReactNode;
}

export default function CatalogModalFrame({
    isOpen,
    onClose,
    title,
    children,
    className = 'max-w-xl',
    bodyClassName = 'p-6 space-y-6',
    formId,
    submitLabel,
    submitDisabled = false,
    footer,
}: CatalogModalFrameProps) {
    const resolvedFooter = footer ?? (formId && submitLabel ? (
        <div className="px-6 py-5 border-t border-gray-100 dark:border-gray-800 flex justify-end gap-3 bg-gray-50/50 dark:bg-gray-800/30">
            <button
                type="button"
                onClick={onClose}
                className="px-6 py-2.5 text-sm font-bold text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-all"
            >
                Cancel
            </button>
            <button
                type="submit"
                form={formId}
                disabled={submitDisabled}
                className="px-6 py-2.5 text-sm font-bold text-white bg-brand-500 border border-brand-500 rounded-xl hover:bg-brand-600 shadow-[0_4px_12px_rgba(59,130,246,0.3)] transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {submitLabel}
            </button>
        </div>
    ) : null);

    return (
        <Modal isOpen={isOpen} onClose={onClose} className={className} showCloseButton={false}>
            <div className="flex flex-col max-h-[90vh] bg-white dark:bg-gray-900 rounded-3xl overflow-hidden shadow-2xl">
                <div className="px-6 py-5 border-b border-gray-100 dark:border-gray-800 flex justify-between items-center bg-white dark:bg-gray-900">
                    <h3 className="text-xl font-bold text-gray-800 dark:text-white">{title}</h3>
                    <button
                        onClick={onClose}
                        className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className={`flex-1 overflow-y-auto ${bodyClassName}`}>
                    {children}
                </div>

                {resolvedFooter}
            </div>
        </Modal>
    );
}
